module.exports = __webpack_public_path__ + "media/images/join-as-doctor-sf-bg-a565502e88248ea17861d68f1580ffd3.png";